import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import HomeFeedSearch from '../../common/search/HomeFeedSearch';
import CollapseBar from '../../common/collapse-bar/CollapseBar';

const HomeFeedFilter = ({
  selectedFilter,
  setSelectedFilter,
  setFeedList,
  setQuery,
  onMyCampClick,
  getFeed,
}) => {
  const [inputText, setInputText] = useState(null);
  const [debouncedValue, setDebouncedValue] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputText); // Update only after the delay
    }, 500); // Delay time in milliseconds

    // Cleanup timeout if inputValue changes before the delay time
    return () => {
      clearTimeout(handler);
    };
  }, [inputText]);

  useEffect(() => {
    if (debouncedValue) {
      setFeedList(null);
      setQuery((prevQuery) => {
        const p = {
          ...prevQuery,
          trending: false,
          has_more: true,
          title: inputText,
        };
        delete p.group_id;
        delete p.camp_id;
        delete p.starting_after;
        return p;
      });
      setSelectedFilter(inputText);
    }
  }, [debouncedValue]);

  const handleInputChange = (value) => {
    if (value) {
      setInputText(value);
    } else {
      setInputText(value);
      setFeedList(null);
      setQuery((prevQuery) => {
        const p = {
          ...prevQuery,
          trending: true,
          has_more: true,
        };
        delete p.title;
        delete p.group_id;
        delete p.camp_id;
        delete p.starting_after;
        return p;
      });
      setSelectedFilter('trending');
    }
  };

  const onFilterClick = (filter) => {
    if (selectedFilter === filter) return;
    setInputText(null);
    setFeedList(null);
    setQuery((prevQuery) => {
      const p = {
        ...prevQuery,
        trending: filter === 'trending',
        has_more: true,
      };
      delete p.title;
      delete p.group_id;
      delete p.camp_id;
      delete p.starting_after;
      return p;
    });
    setSelectedFilter(filter);
  };

  return (
    <CollapseBar>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          alignItems: 'center',
          backgroundColor: 'transparent',
          padding: '8px',
          borderRadius: '8px',
          gap: '8px',
          paddingTop: '30px',
        }}
        className="wrap_box_tab"
      >
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'center',
            paddingX: { xs: '8px', sm: '0px' },
            overflowX: { xs: 'auto', md: 'unset' },
            whiteSpace: { xs: 'nowrap', md: 'normal' },
            paddingBottom: { xs: '5px', md: 0 },
          }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor:
                selectedFilter === 'my_camp' ? '#321b6d' : 'white',
              color: selectedFilter === 'my_camp' ? 'white' : '#321b6d',
              textTransform: 'none',
              borderRadius: '25px',
              padding: { xs: '0px 10px', sm: '0px 20px' },
              fontWeight: '700',
              fontFamily: 'Open Sans, sans-serif',
              fontSize: { xs: '0.875rem', sm: '1rem' }, // smaller font size on mobile
              '&:hover': { backgroundColor: '#321b6d', color: 'white' },
              minWidth: { xs: '100px', sm: 'auto' },
            }}
            className="darkfont_feed"
            onClick={() => onMyCampClick('my_camp')}
          >
            ⛺ My Camp
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor:
                selectedFilter === 'latest' ? '#321b6d' : 'white',
              color: selectedFilter === 'latest' ? 'white' : '#321b6d',
              textTransform: 'none',
              borderRadius: '25px',
              padding: { xs: '0px 10px', sm: '0px 20px' },
              fontWeight: '700',
              fontFamily: 'Open Sans, sans-serif',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              '&:hover': { backgroundColor: '#321b6d', color: 'white' },
              minWidth: { xs: '100px', sm: 'auto' },
            }}
            className="darkfont_feed"
            onClick={() => onFilterClick('latest')}
          >
            💡 Latest
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor:
                selectedFilter === 'trending' ? '#321b6d' : 'white',
              color: selectedFilter === 'trending' ? 'white' : '#321b6d',
              textTransform: 'none',
              borderRadius: '25px',
              padding: { xs: '0px 10px', sm: '0px 20px' },
              fontWeight: '700',
              fontFamily: 'Open Sans, sans-serif',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              '&:hover': { backgroundColor: '#321b6d', color: 'white' },
              minWidth: { xs: '100px', sm: 'auto' },
            }}
            className="darkfont_feed"
            onClick={() => onFilterClick('trending')}
          >
            💞 Trending
          </Button>
        </Box>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
            marginTop: { xs: '16px', md: '0px' },
          }}
        >
          <HomeFeedSearch handleInputChange={handleInputChange} />
        </Box>
      </Box>
    </CollapseBar>
  );
};

export default HomeFeedFilter;
